import { Link, type LinkProps } from "@tanstack/react-router";
import { cn } from "@/lib/utils";

export function RuledList({ children, className }: { children: React.ReactNode; className?: string }) {
  return <ul className={cn("divide-y divide-border border-y border-border", className)}>{children}</ul>;
}

interface RuledListItemProps {
  children: React.ReactNode;
  className?: string;
  to?: LinkProps["to"];
  params?: LinkProps["params"];
}

export function RuledListItem({ children, className, to, params }: RuledListItemProps) {
  const inner = cn("flex min-h-10 items-center justify-between gap-4 py-2 text-[13.5px]", className);
  if (to) {
    return (
      <li>
        <Link to={to} params={params} className={cn(inner, "hover:bg-accent -mx-2 px-2")}>
          {children}
        </Link>
      </li>
    );
  }
  return <li className={inner}>{children}</li>;
}
